const booksReducerDefaultState = [];

export default (state = booksReducerDefaultState, action) => {
  switch (action.type) {
    case 'ADD_DUA':
      return [...state, action.dua];
    case 'ADD_VIDEO':
      return [...state, action.video];
    case 'ADD_EVENT':
      return [...state, action.event];
    case 'ADD_EMAIL':
      return [...state, action.email.EmailId];
    case 'GET_DUAS':
      return action.duas;
    case 'GET_VIDEOS':
      return action.videos;
    case 'GET_EVENTS':
      return action.events;
    case 'GET_CATEGORIES':
      return action.categories;
    case 'UPDATE_DUA':
      return action.duaObj;
    case 'UPDATE_VIDEO':
      return action.videoObj;
    case 'UPDATE_EVENT':
      return action.eventObj;
    case 'GET_SECTION_LIST':
      return action.list;
    case 'REMOVE_RECORD':
      return state.filter(({ id }) => id !== action.id);
    case 'GET_STREAM_URL':
      return action.bayansList;
    case 'REMOVE_LIVE_STREAMING_URL':
      return state !== action.url;
    default:
      return state;
  }
};
